import {CopilotIcon, PaperAirplaneIcon} from '@primer/octicons-react'
import {Button, Stack} from '@primer/react'
import {Blankslate} from '@primer/react/experimental'

import styles from './AskCopilotNoReadmeCard.module.css'
import {useAskCopilotPrompts} from './use-ask-copilot-prompts'

/**
 * Blankslate card shown in the repo overview when no README is present.
 * Invites users to ask Copilot about the repository instead.
 */
export function AskCopilotNoReadmeCard() {
  const {prompts, onPromptClick} = useAskCopilotPrompts({location: 'no-readme-card', readme: false})

  return (
    <Blankslate>
      <Blankslate.Visual>
        <CopilotIcon size={36} />
      </Blankslate.Visual>
      <Blankslate.Heading>Ask Copilot about this repository</Blankslate.Heading>
      <Blankslate.Description>
        This repository doesn&apos;t have a README yet. Ask Copilot to learn how this project works.
      </Blankslate.Description>
      <Stack direction="horizontal" gap="condensed" wrap="wrap" justify="center" className={styles.PromptActions}>
        {prompts.map(prompt => (
          <Button
            key={prompt.label}
            variant="default"
            leadingVisual={PaperAirplaneIcon}
            onClick={() => onPromptClick(prompt)}
          >
            {prompt.label}
          </Button>
        ))}
      </Stack>
    </Blankslate>
  )
}
